import { getAnalyticsClient, isSSR, Logger, pollForBrowserControlsFlag } from '../../../common/utils';
import { getBscGlobalState, initializeGlobalState } from '../../../common/utils/bsc-global-state';
import { StorageType } from '../../../services/web-storage-service';
import { createDocumentCookiePassthrough } from './create-document-cookie-passthrough';
import { createWebStoragePassthrough } from './create-web-storage-passthrough';
export const initializeControls = async (args = {}) => {
  try {
    initializeGlobalState(args);

    // Exit silently if in SSR context
    if (isSSR()) {
      return;
    }
    const isBSCFlagEnabled = await pollForBrowserControlsFlag();
    if (!isBSCFlagEnabled) {
      return;
    }

    // Ensures that the AWC is constructed before overwriting any native methods.
    const analyticsWebClientInstance = getAnalyticsClient();

    // If AWC is not initialized, it will be undefined
    const isAnalyticsInitialized = !!analyticsWebClientInstance;
    if (!isAnalyticsInitialized) {
      throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
    }
    await createDocumentCookiePassthrough();
    const isWebStorageControlsEnabled = getBscGlobalState().webStorageEnabled;
    if (!isWebStorageControlsEnabled) {
      return;
    }
    await createWebStoragePassthrough(StorageType.LocalStorage);
    await createWebStoragePassthrough(StorageType.SessionStorage);
  } catch (e) {
    Logger.errorWithOperationalEvent({
      action: 'initializeControlsError',
      message: `Failed to initialize browser storage controls. ${e.message || ''}`
    });
  }
};
export { createDocumentCookiePassthrough, createWebStoragePassthrough };